export const passwordRequirements = (password: string) => [
  { label: 'Almeno 8 caratteri', valid: password.length >= 8 },
  { label: 'Almeno una lettera maiuscola', valid: /\p{Lu}/u.test(password) },
  { label: 'Almeno una lettera minuscola', valid: /\p{Ll}/u.test(password) },
  { label: 'Almeno un numero', valid: /\p{Nd}/u.test(password) },
];

export const isPasswordValid = (password: string) => passwordRequirements(password).every(rule => rule.valid);

export function passwordError(error: any): string {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map(item => item.msg?.replace(/^Value error, /, '')).filter(Boolean).join('. ');
  return typeof detail === 'string' ? detail : 'Impossibile salvare la password. Riprova.';
}

export default function PasswordRequirements({ password }: { password: string }) {
  return <ul aria-label="Requisiti password" className="text-sm space-y-1" aria-live="polite">
    {passwordRequirements(password).map(rule => <li key={rule.label} className={rule.valid ? 'text-green-700' : 'text-gray-600'}>
      <span aria-hidden="true">{rule.valid ? '✓' : '○'} </span>{rule.label}<span className="sr-only">{rule.valid ? ': soddisfatto' : ': da soddisfare'}</span>
    </li>)}
  </ul>;
}
